"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsDocumentHidden = getIsDocumentHidden;
exports.usePageVisible = usePageVisible;

var _react = require("react");

function getIsDocumentHidden() {
  return typeof document !== "undefined" && !document.hidden;
}

function usePageVisible(callback) {
  var onVisibilityChange = function onVisibilityChange() {
    callback(getIsDocumentHidden());
  };

  (0, _react.useEffect)(function () {
    if (typeof document === "undefined") {
      return;
    }

    document.addEventListener("visibilitychange", onVisibilityChange, false);
    return function () {
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  });
}